module.exports = __webpack_public_path__ + "static/media/18ECA8.497d7b15.jpg";